import styled from '@emotion/styled';

import SellerInformation, {
  SellerInformationProps
} from '../../../SellerInformation';

export type StyledSellerInformationProps = SellerInformationProps;

const StyledSellerInformation = styled(
  SellerInformation
)<StyledSellerInformationProps>({
  marginBottom: 16
});

export default StyledSellerInformation;
